import React, {PropsWithChildren} from 'react';
import Button from '../../../incase-domain/components/button/Button';

interface HoverMenuProps {
    onCopy?: () => void;
    onDelete?: () => void;
    onOptions?: () => void;
    onRemove?: () => void;
    style?: React.CSSProperties;
}

function HoverMenu(props: PropsWithChildren<HoverMenuProps>): JSX.Element {
    const {onCopy, onDelete, onOptions, children, onRemove, style} = props;

    return (
        <div className="c-hoverMenu" style={style}>
            <div className="c-hoverMenu__children">{children}</div>
            <div className="u-flex u-flex-row c-hoverMenu__generalControls">
                {onCopy && <Button size="sm" variant="ghost" leading="solar:copy-linear" square onClick={onCopy} />}
                {onDelete && <Button size="sm" variant="ghost" leading="solar:trash-bin-minimalistic-linear" square onClick={onDelete} />}
                {onOptions && <Button size="sm" variant="ghost" leading="solar:pen-2-linear" square onClick={onOptions} />}
                {onRemove && <Button size="sm" variant="ghost" leading="ph:x-bold" square onClick={onRemove} />}
            </div>
        </div>
    );
}

export default HoverMenu;
